module.exports = __webpack_public_path__ + "static/media/MTL_ASC_TNK3.8c9f09b0.png";